import { Delete16Regular, Edit16Regular } from '@fluentui/react-icons';
import ConfirmDeleteDialog from '../ui/ConfirmDeleteDialog';
import React from 'react';

interface FormListDataItem {
  id: string | number;
  title?: string;
  value?: string | React.ReactNode;
}

interface FormListItemProps {
  children: React.ReactNode;
}

const FormListItem: React.FC<FormListItemProps> = ({ children }) => {
  return (
    <div
      key={1}
      className="size-7 hover:bg-color7 hover:text-white flex items-center justify-center"
    >
      {children}
    </div>
  );
};

interface FormListProps {
  data?: FormListDataItem[];
  withValue?: boolean;
  onDelete: (id: string | number) => void;
  onEdit?: (id: string | number) => void;
}

const FormList: React.FC<FormListProps> = ({ data, withValue, onDelete, onEdit }) => {
  if (!data || !Array.isArray(data)) return null;

  return (
    <ul className="flex flex-col p-1">
      {data.filter(Boolean).map((ele, i) => (
        <li
          key={i}
          className="flex w-full text-neutral-500 text-sm border-b border-neutral-200 items-center"
        >
          {withValue ? (
            <span className="grow">
              <span className="mr-2">{ele.title}</span>
              <span>{ele.value}</span>
            </span>
          ) : (
            <span className="grow">{ele.title}</span>
          )}
          <div className="shrink-0 flex cursor-pointer items-center">
            {onEdit && (
              <FormListItem key={1}>
                <Edit16Regular
                  className="shrink-0"
                  data-testid={`form-list-edit-btn-${ele.id}`}
                  onClick={() => onEdit(ele.id)}
                />
              </FormListItem>
            )}
            <FormListItem key={2}>
              <ConfirmDeleteDialog onConfirm={() => onDelete(ele.id)}>
                <Delete16Regular
                  className="shrink-0 cursor-pointer"
                  data-testid={`form-list-delete-btn-${ele.id}`}
                />
              </ConfirmDeleteDialog>
            </FormListItem>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default FormList;
